module.exports = {
    ok:'确定',
    close:'关闭',
    please: '请在',    
    hour: '小时',
    minutes:'分钟',
    pay_countdown:'内完成支付，剩余支付时间',
    order_cancel:'秒内完成支付，否则订单取消！',
    pay_wechat:'微信支付',
    min:'分',
    overtime_refresh:'秒内完成支付，超时二维码将过期，请刷新页面重新获取。',  
    color_black: '曜石黑',
    color_orange: '爱马仕橙',
    color_blue: '科技蓝'    
}



// WEBPACK FOOTER //
// ./js/src/i18n/salecomponents/cn.js